import React from 'react';
import PropTypes from 'prop-types';

/**
 * The row a list shows when it has nothing to show.
 *
 * Every list here said the same thing — "No purchase matches these filters" —
 * whether or not there were any filters. On an unfiltered list that sentence is
 * simply false, and it is false in the most misleading direction: it tells
 * somebody the answer depends on a search they never made, so the next thing
 * they do is go and change filters that are not set.
 *
 * Two different situations, two different sentences, and only one of them has
 * anything to do:
 *
 *   - filters applied → say so, and offer to drop them.
 *   - nothing applied → the list really is empty, and there is nothing to try.
 *
 * The distinction costs one boolean and saves the minute somebody spends
 * looking for the filter that is hiding their data.
 */

export default function EmptyRow({ columns, noun, filtered, onClear }) {
  return (
    <tr>
      <td colSpan={columns} className="next-muted next-table__note">
        {filtered ? (
          <>
            No {noun} matches these filters.
            {onClear && (
              <>
                {' '}
                <button type="button" className="next-btn next-btn--quiet next-btn--sm" onClick={onClear}>
                  Clear filters
                </button>
              </>
            )}
          </>
        ) : (
          `There is no ${noun} here.`
        )}
      </td>
    </tr>
  );
}

EmptyRow.propTypes = {
  columns: PropTypes.number.isRequired,
  // Singular: "no purchase matches", "there is no purchase here".
  noun: PropTypes.string.isRequired,
  filtered: PropTypes.bool,
  onClear: PropTypes.func
};
